module.exports = __webpack_public_path__ + "img/annotation_active.6b2236c1.svg";